import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { advanceJourney, fetchETA } from 'redux/modules/journey-stops/effects';
import StageActions from './component';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';
import { getETAerror } from 'redux/modules/journey-stops/selectors';
import { getTimeDone } from 'redux/modules/journeys/stop-status-log';

const getPreviousStage = {
  ONROUTE: 'DONE',
  PENDING: 'ONROUTE',
  DONE: 'PENDING',
};

const firstStageOfStop = ['ONROUTE'];

export default compose(
  withJourneyCardSelectors,
  connect(
    (state, props) => {
      const { selectors, stopId, journeyId, stage } = props;

      const { driver, route = {} } =
        selectors.getJourneyFields(state, journeyId, ['driver', 'route']) || {};

      const {
        stop_type,
        address = {},
        shipment_state_logs,
      } = selectors.getJourneyStopFields(state, journeyId, stopId, [
        'stop_type',
        'address',
        'shipment_state_logs',
      ]) || {};

      const { stop_type: previous_stop_type, shipment_state_logs: previous_shipment_state_logs } =
        selectors.getJourneyStopFields(state, journeyId, stopId - 1, [
          'stop_type',
          'shipment_state_logs',
        ]) || {};
      const previousStageTimeDone = getTimeDone(getPreviousStage[stage], {
        shipment_state_logs: firstStageOfStop.includes(stage)
          ? previous_shipment_state_logs
          : shipment_state_logs,
        stop_type: firstStageOfStop.includes(stage) ? previous_stop_type : stop_type,
      });

      const { city, zipcode, address_line, company_name } = address || {};
      const { country } = route || {};
      return {
        driverId: driver ? driver.id : undefined,
        stopType: stop_type,
        city,
        zipcode,
        country,
        address_line,
        etaError: getETAerror(state, journeyId),
        company_name,
        previousStageTimeDone,
      };
    },
    {
      advanceJourney,
      fetchETA,
    }
  ),
  withHandlers({
    handleAdvance:
      ({ actionSource, advanceJourney, company_name, journeyId, stopId, stage, stopType }) =>
      (e, time) => {
        e.preventDefault();
        e.stopPropagation();
        if (!advanceJourney) {
          return;
        }

        advanceJourney({
          actionSource,
          journeyId,
          stopId,
          stopType,
          stage,
          companyName: company_name,
          time,
        });
      },
    onGetEtaClick:
      ({ journeyId, fetchETA, driverId, city, zipcode, country, address_line, actionSource }) =>
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        fetchETA({
          journeyId,
          driver: driverId,
          address: { city, zipcode, country_code: country, address_line },
          actionSource,
        });
      },
  })
)(StageActions);
